import * as React from 'react'

import { IItem } from '../../../../../typings/searchResults'
import CollectionButton from '../../../buttons/collectionButton'
import FavoriteButton from '../../../buttons/favoriteButton/favoriteButton'

import * as styles from './favButtons.module.css'

interface IProps {
  item: IItem
  onAddToCollections: React.EventHandler<any>
  onAddToFavourites: React.EventHandler<any>
}

const FavButtons = ({
  item,
  onAddToCollections,
  onAddToFavourites
}: IProps) => {
  const { id, ui: { isInBookmarks, isInFavourites } } = item

  return (
    <React.Fragment>
      <CollectionButton
        href={`/bookmarks/widget?item_id=${id}`}
        onClick={onAddToCollections}
        isActive={isInBookmarks}
        className={styles.circleButton}
        iconClassName={styles.iconBase}
      />
      <FavoriteButton
        href={`/favorites?item_id=${id}`}
        onClick={onAddToFavourites}
        isActive={isInFavourites}
        className={styles.circleButton}
        iconClassName={styles.iconBase}
      />
    </React.Fragment>
  )
}

export default FavButtons
